// 网站分析和统计组件

interface AnalyticsProps {
  googleAnalyticsId?: string;
  baiduAnalyticsId?: string;
}

export function Analytics({ googleAnalyticsId, baiduAnalyticsId }: AnalyticsProps) {
  return (
    <>
      {/* Google Analytics */}
      {googleAnalyticsId && (
        <>
          <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId}`}
          />
          <script
            dangerouslySetInnerHTML={{
              __html: `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${googleAnalyticsId}', {
                  page_title: document.title,
                  page_location: window.location.href,
                  anonymize_ip: true,
                  allow_google_signals: false,
                  allow_ad_personalization_signals: false
                });
              `
            }}
          />
        </>
      )}

      {/* 百度统计 */}
      {baiduAnalyticsId && (
        <script
          dangerouslySetInnerHTML={{
            __html: `
              var _hmt = _hmt || [];
              (function() {
                var hm = document.createElement("script");
                hm.src = "https://hm.baidu.com/hm.js?${baiduAnalyticsId}";
                var s = document.getElementsByTagName("script")[0]; 
                s.parentNode.insertBefore(hm, s);
              })();
            `
          }}
        />
      )}

      {/* 微软 Clarity (可选) */}
      <script
        dangerouslySetInnerHTML={{
          __html: `
            (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "YOUR_CLARITY_ID");
          `
        }}
      />
    </>
  );
}

// 事件追踪函数
export function trackEvent(eventName: string, parameters?: Record<string, any>) {
  // Google Analytics 事件追踪
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, parameters);
  }
  
  // 百度统计事件追踪
  if (typeof window !== 'undefined' && (window as any)._hmt) {
    (window as any)._hmt.push(['_trackEvent', eventName, parameters?.category || 'interaction', parameters?.label || '']);
  }
}

// 页面浏览追踪
export function trackPageView(url: string, title?: string) {
  // Google Analytics 页面浏览追踪
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('config', 'GA_MEASUREMENT_ID', {
      page_path: url,
      page_title: title || document.title
    });
  }
  
  // 百度统计页面浏览追踪
  if (typeof window !== 'undefined' && (window as any)._hmt) {
    (window as any)._hmt.push(['_trackPageview', url]);
  }
}

// 转化追踪
export function trackConversion(conversionName: string, value?: number) {
  trackEvent('conversion', {
    conversion_name: conversionName,
    value: value,
    currency: 'CNY'
  });
}

// 用户行为追踪
export function trackUserAction(action: string, category: string, label?: string) {
  trackEvent('user_action', {
    action,
    category,
    label
  });
}